import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';

/** A Segment tracking event for when the user visits the signup page after being referred by a vet. */
export function trackVetReferredSignupVisitedSignup() {
  track(segmentTrackEvents.vet_referred_signup_visited_signup);
}
